"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
const _excluded = ["className", "cnCheckBox", "color", "checked", "onChange", "label", "labelVariant"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * チェックボックス部品
 * @param {boolean|number} checked - 選択値
 * @param {func} onChange - 変更時のハンドラ<br/>
 * シグネチャ：(checked:bool):void
 * @param {string|node} label - チェックボックスのラベル
 * @param {string} cnCheckBox - 内包チェックボックスに指定するcssクラス名
 */
const CCheckBox = function (props) {
  const {
      className,
      cnCheckBox,
      color,
      checked,
      onChange,
      label,
      labelVariant
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const handleChange = function (event) {
    onChange(event.target.checked);
  };
  const renderedLabel = typeof label === 'string' && labelVariant ? /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: labelVariant
  }, label) : label;

  // number (0/1) が渡された場合も boolean に正規化
  const normalizedChecked = typeof checked === 'number' ? checked !== 0 : !!checked;
  return /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
    className: className,
    control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, _extends({
      className: cnCheckBox
    }, rest, {
      color: color,
      checked: normalizedChecked,
      onChange: handleChange
    })),
    label: renderedLabel
  });
};
CCheckBox.propTypes = {
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]).isRequired,
  onChange: _propTypes.default.func.isRequired,
  label: _propTypes.default.node,
  labelVariant: _propTypes.default.string
};
var _default = exports.default = CCheckBox;